import { Heading, List, Text } from "@chakra-ui/react";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { Link } from "react-router-dom";

const RichTextRenderer = ({ content }) => {
  return (
    <BlocksRenderer
      content={content}
      blocks={{
        // You can use the default components to set class names...
        paragraph: ({ children }) => (
          <p className="text-neutral900 max-w-prose">{children}</p>
        ),
        // ...or point to a design system
        heading: ({ children, level }) => {
          switch (level) {
            case 1:
              return <Heading as="h1">{children}</Heading>;
            case 2:
              return <Heading as="h2">{children}</Heading>;
            case 3:
              return <Heading as="h3">{children}</Heading>;
            case 4:
              return <Heading as="h4">{children}</Heading>;
            case 5:
              return <Heading as="h5">{children}</Heading>;
            case 6:
              return <Heading as="h6">{children}</Heading>;
            default:
              return <Heading as="h1">{children}</Heading>;
          }
        }, // For links, you may want to use the component from your router or framework
        link: ({ children, url }) => <Link to={url}>{children}</Link>,
        list: ({ children, format }) => {
          if (format === "ordered") {
            return (
              <List.Root as="ol" gap={2} pl={4}>
                {children}
              </List.Root>
            );
          }
          return (
            <List.Root as="ul" gap={2} pl={4}>
              {children}
            </List.Root>
          );
        },
        "list-item": ({ children }) => <List.Item>{children}</List.Item>,
      }}
      modifiers={{
        // bold: ({ children }) => <strong>{children}</strong>,
        italic: ({ children }) => <Text fontStyle="italic">{children}</Text>,
      }}
    />
  );
};

export default RichTextRenderer;
